import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {compose} from 'redux';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';
import * as R from 'ramda';
import {Icon} from "antd"
import * as moment from "moment-timezone";

// Context API HOC for breadcrumb rendering
// Based on https://github.com/charlieduong94/react-breadcrumbs-context

const initialValue = {
  crumbs: [],
  addCrumb: (crumb) => {},
  removeCrumb: (crumb) => {},
};

export const BreadcrumbContext = React.createContext(initialValue);

export const PathBreadcrumbItem = ({ path, resource }) => {
  // Catch for both types with and without permissions
  resource = resource.resource || resource;
  return !resource ?
    <div className='breadcrumb'>loading...</div> :
    <div key={path + resource.id}>
      <Link to={path + resource.id} className='breadcrumb'>{resource.name}</Link>
    </div>;
};

export const BreadcrumbItem = ({ item }) => {
  if (item) {
    return (
      <div
        key={`/bids/${item.resource.id}`}
      >
        <Link
          to={`/bids/${item.resource.id}`}
          className='breadcrumb'
        >
          {item.resource.name}
        </Link>
      </div>
    );
  } else {
    return (
      <div className='breadcrumb'>
        loading...
      </div>
    );
  }
};

export class _BreadcrumbProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crumbs: [
        { title: <Icon type="home" theme="filled" style={{marginBottom: 1}} />, path: '/' }
      ]
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    moment.tz.guess(true);
    console.log('Refreshed moment TZ');
  }

  addCrumb = (crumb) => {
    this.setState(({ crumbs: current }) => ({
      crumbs: [...current, crumb]
    }));
  };

  removeCrumb = (crumb) => {
    this.setState(({ crumbs: current }) => {
      let newCrumbs = [...current];
      newCrumbs = newCrumbs.filter(v => {
        return !(v.path === crumb.path && v.title === crumb.title);
      });
      return { crumbs: newCrumbs };
    });
  };

  render() {
    const { crumbs } = this.state;
    const { children } = this.props;
    const context = {
      crumbs,
      addCrumb: this.addCrumb,
      removeCrumb: this.removeCrumb,
    };
    return (
      <BreadcrumbContext.Provider value={context}>{children}</BreadcrumbContext.Provider>
    );
  }
}

export const BreadcrumbProvider = compose(
  withRouter
)(_BreadcrumbProvider);

class BreadcrumbWrapper extends Component {
  constructor(props) {
    super(props);
    const { addCrumb, crumb } = props;
    addCrumb(crumb);
  }

  componentWillUnmount() {
    const { crumb, removeCrumb } = this.props;
    removeCrumb(crumb);
  }

  render() {
    return this.props.children;
  }
}

export function withBreadcrumb(crumb, WrappedComponent) {
  return (props) => {
    return <BreadcrumbContext.Consumer>
      { ({addCrumb, removeCrumb}) => (
        <BreadcrumbWrapper
          crumb={typeof crumb === 'function' ? crumb(props) : crumb}
          addCrumb={addCrumb}
          removeCrumb={removeCrumb}
        >
          <WrappedComponent {...props}/>
        </BreadcrumbWrapper>
      )}
    </BreadcrumbContext.Consumer>
  };
}

export const withBreadcrumbCurried = R.curry(withBreadcrumb);

export const withBreadcrumbFromResource = (path, id) => withBreadcrumb(() => connect((state, props) => ({ path, item: state.view.data[props.id] }))(BreadcrumbItem)({ props: {id} }));



// WEBPACK FOOTER //
// ./src/components/Boilerplate/BreadcrumbContext.js